import { render, staticRenderFns } from "./pfnodedetail.vue?vue&type=template&id=0bff347f&scoped=true&"
import script from "./pfnodedetail.vue?vue&type=script&lang=js&"
export * from "./pfnodedetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff347f",
  null
  
)

export default component.exports